import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import css from '../css/index.m.css';
const factory = create({
    theme
}).properties();
export const ContentContainer = factory(({ id: widgetId, properties, children, middleware: { theme } }) => {
    const { container } = theme.classes(css);
    const { xqa = 'mc-content-container', id, key = `content-containerid-${id || widgetId}`, additionalClasses = [], tabIndex = 0 } = properties();
    return v('div', { xqa, key, id, widgetId, tabIndex, classes: [theme.variant(), container, ...additionalClasses] }, children());
});
export default ContentContainer;
